const ConvertTime = ({ time }) => {
    if (!time) return null;

    const [hours, minutes] = time.split(":").map(Number);

    const displayHours = hours % 12 || 12;

    return (
        <span className="text-black">
            {displayHours}:{minutes.toString().padStart(2, "0")}{" "}
            {hours >= 12 ? "PM" : "AM"}
        </span>
    );
};

export default ConvertTime;
